import React from 'react';
import styled from 'styled-components';
import StyleConfig from 'src/constants/StyleConfig';

interface Props {
  text: string;
}

export const ListText = ({ ...props }: Props) => {
  return <P>{props.text}</P>;
};

const P = styled.p`
  font-size: 14px;
  line-height: 1;
  color: ${StyleConfig.COLOR.TEXT_COLOR};
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
`;
export default ListText;
